import { useState } from "react";
import UkazkaRestauracia from "./UkazkaRestauracia";
import UkazkaVodic from "./UkazkaVodic";
import "./Ukazky.scss";

/**
 * Animovane ukazky v sekcii "Ako to funguje" -- prepinac medzi pohladom
 * prevadzky (admin panel) a vodica (mobil + mapa).
 *
 * Neaktivna ukazka ma `hidden`: nevidno ju, takze jej useScenar stoji
 * (IntersectionObserver) a po prepnuti zacne od zaciatku.
 */
const KARTY = [
  {
    key: "restauracia",
    nazov: "Reštaurácia",
    popis: "Dispečer zapíše objednávku, pošle ju na trasu, v prehľade vidí tržbu a dlh zákazníka vyrovná jedným klikom.",
    Ukazka: UkazkaRestauracia,
  },
  {
    key: "vodic",
    nazov: "Vodič",
    popis: "Vodič má zastávky v mobile, adresa ho navedie a pri doručení zapíše platbu — aj so splátkou dlhu.",
    Ukazka: UkazkaVodic,
  },
];

function Ukazky() {
  const [aktivna, setAktivna] = useState(KARTY[0].key);

  return (
    <div className="ukazky">
      <div className="ukazky__tabs" role="tablist" aria-label="Ukážka">
        {KARTY.map((k) => (
          <button
            key={k.key}
            type="button"
            role="tab"
            id={`ukazky-tab-${k.key}`}
            aria-selected={aktivna === k.key}
            aria-controls={`ukazky-panel-${k.key}`}
            className={`ukazky__tab${aktivna === k.key ? " ukazky__tab--aktivna" : ""}`}
            onClick={() => setAktivna(k.key)}
          >
            {k.nazov}
          </button>
        ))}
      </div>

      {KARTY.map(({ key, popis, Ukazka }) => (
        <div
          key={key}
          role="tabpanel"
          id={`ukazky-panel-${key}`}
          aria-labelledby={`ukazky-tab-${key}`}
          hidden={aktivna !== key}
          className="ukazky__panel"
        >
          <p className="ukazky__popis">{popis}</p>
          <Ukazka />
        </div>
      ))}
    </div>
  );
}

export default Ukazky;
